import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ReadMore } from 'components/common/readMore';
import { stripHTMLTags } from '../../lib';
import { MdFreeBreakfast } from 'react-icons/md';
import { Channel } from 'components/channel';
import { Stars } from 'components/common/stars';
import { useGetBookingData } from 'hooks';

const MobilePropertyCard = ({
    Lang = {},
    property = {},
    openPropertyDetails,
}) => {
    const { currencySymbol } = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice
    );

    const { getBookingData } = useGetBookingData();

    const handlePropertyClick = () => {
        openPropertyDetails(property?.propertyID);
        getBookingData({
            propertyId: property?.propertyID,
            parentPropertyId: property?.parentPropertyID,
        });
    };

    return (
        <div className="ab-room-row expanded">
            <div className="ab-room-row-main">
                <div className="ab-bestprice-ribbon-multiproperty">
                    {property.ourPrice.text}
                </div>
                <div
                    className="ab-room-image-container"
                    onClick={handlePropertyClick}
                >
                    <div
                        className="ab-room-image"
                        style={{
                            backgroundImage: `url("${property.propertyLogo}")`,
                        }}
                    ></div>
                </div>
                <div className="ab-room-middle-container">
                    <div
                        className="ab-room-middle-upper"
                        onClick={handlePropertyClick}
                    >
                        <div className="ab-room-upper-head">
                            <div className="ab-room-upper-name">
                                {property.propertyName}
                            </div>
                            <span className="ab-small-score">
                                <div className="ab-stars">
                                    <Stars
                                        rating={property.propertyStars}
                                        color={'#000'}
                                    />
                                </div>
                                <span className="ab-small-score-inner">
                                    {property.scoreRating}{' '}
                                    <b>{property.totalScoreDecimal}</b>
                                </span>
                            </span>
                            <span className="ab-small-score-inner">
                                {property?.ariaLocation}
                            </span>
                            <div className="ab-room-upper-description">
                                <ReadMore
                                    moreText={Lang.more}
                                    lessText={Lang.less}
                                >
                                    {stripHTMLTags(
                                        property.propertyDescription
                                    )}
                                </ReadMore>
                            </div>
                        </div>
                        <div className="ab-room-upper-notes">
                            <div className="ab-room-upper-save ab-save-box">
                                {property.ourPrice?.hasBreakfast ? (
                                    <>
                                        <div className="ab-freebies">
                                            <div className="ab-freebie">
                                                <MdFreeBreakfast size={20} />
                                                <span className="ab-breakfast-text">
                                                    {Lang?.breakfastText}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {property.availableRooms > 0 && (
                                <div className="ab-room-upper-occupancy">
                                    {Lang?.only} {property.availableRooms}{' '}
                                    {Lang?.roomsLeft}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ab-room-middle-footer">
                        <div
                            className="ab-prices-div"
                            onClick={handlePropertyClick}
                        >
                            {property.ourPrice?.loyaltyprice &&
                            property.ourPrice?.loyaltyprice !== '0' ? (
                                <>
                                    <div
                                        className="ab-price"
                                        tabIndex="0"
                                        role="button"
                                    >
                                        {property.ourPrice?.loyaltyprice}{' '}
                                        {currencySymbol}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div
                                        className="ab-price"
                                        tabIndex="0"
                                        role="button"
                                    >
                                        {property.ourPrice?.price}{' '}
                                        {currencySymbol}
                                    </div>
                                </>
                            )}
                            {property.propertySite && (
                                <a
                                    className="ab-official-site-text"
                                    href={property.propertySite}
                                >
                                    {Lang?.officialSite}
                                </a>
                            )}
                        </div>
                        <div className="ab-buttons-div">
                            <a
                                role="button"
                                className="ab-book-button ab-book-button--default undefined"
                                tabIndex="0"
                                aria-disabled="false"
                                href={property?.ourPrice?.bigPluginUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="ab-book-button-container">
                                    <div className="ab-book-button-content">
                                        <span>{Lang?.bookNowText}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ab-room-more-offers" onClick={handlePropertyClick}>
                <div className="ab-room-extra-offer ab-multi-channels-wrapper">
                    {property.channels.length > 0 && (
                        <div className="ab-desktop-widget-channels">
                            {property.channels.map((channel, index) => {
                                let styles = {};
                                if (index >= 3) {
                                    styles = {
                                        marginTop: '7px',
                                    };
                                }
                                return (
                                    <Channel
                                        logo={channel?.logo}
                                        name={channel?.name}
                                        currencySymbol={channel?.currencySymbol}
                                        price={channel?.price}
                                        key={`${property?.propertyID}-${channel?.channelID}`}
                                        extraClasses={[
                                            'ab-channel--desktop ab-channel--multiproperty',
                                        ]}
                                        styles={{
                                            ...styles,
                                        }}
                                        logoSize={15}
                                        channelId={channel?.channelID}
                                        isMultiproperty={true}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

MobilePropertyCard.propTypes = {
    property: PropTypes.object,
    Lang: PropTypes.object,
    openPropertyDetails: PropTypes.func,
};

export default MobilePropertyCard;
